import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { resultStats } from '../../data/content';
export function Results() {
  return <section className="bg-brand-900 px-5 py-16 sm:py-24" data-id="element-291" data-mp="170shquxzik7g">
      <div className="mx-auto max-w-4xl" data-id="element-292" data-mp="171bxc505wwib">
        <SectionHeading tone="dark" eyebrow="What changes after 7 days?" title="A concrete promise, not a miracle" subtitle="I don’t promise that seven days will solve every problem in your life. The promise is much more concrete:" data-id="element-293" data-mp="1c05eq8ikl7nr" />
        <p className="mx-auto mt-8 max-w-2xl rounded-2xl bg-white/10 p-6 text-center text-[17px] leading-relaxed text-white sm:text-lg" data-id="element-294" data-mp="oa1b415dt7wr">
          After 7 days, you will have completed a structured Apometry-inspired routine for approximately{' '}
          <strong data-id="element-295" data-mp="3rq00qcfxttsr">15 minutes a day</strong>, which you can return to and use as a starting point for your personal
          practice.
        </p>
        <p className="mt-10 text-center text-sm font-bold uppercase tracking-wider text-gold" data-id="element-296" data-mp="i42sk154y0e">
          The result you can actually measure
        </p>
        <dl className="mt-5 grid grid-cols-2 gap-3 md:grid-cols-4" data-id="element-297" data-mp="2502yg4raz97p">
          {resultStats.map(s => <div key={s.label} className="rounded-2xl bg-white p-5 text-center" data-id="element-298" data-mp="206i8mzzv5ljl">
              <dt className="sr-only" data-id="element-299" data-mp="1v7x8f0km31v5">{s.label}</dt>
              <dd className="font-display text-4xl font-extrabold text-brand-700 sm:text-5xl" data-id="element-300" data-mp="1v75kmbx9a8ff">{s.value}</dd>
              <dd className="mt-1 text-sm font-semibold uppercase tracking-wide text-ink-soft" data-id="element-301" data-mp="1laskav77gwbp">{s.label}</dd>
            </div>)}
        </dl>
        <CtaButton label="I want my 15-minute routine" className="mt-12" data-id="element-302" data-mp="1ha093werwhcs" />
      </div>
    </section>;
}